if (!customElements.get('variant-collapsible-content')) {
  customElements.define(
    'variant-collapsible-content',
    class VariantCollapsibleContent extends HTMLElement {
      abortController = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.variantChangeUnsubscriber?.();
      }

      handleVariantChange({ data: { variant } }) {
        if (
          !variant?.id ||
          !this.dataset.productUrl ||
          !this.querySelector('[data-dynamic-collapsible-content="true"]')
        ) {
          return;
        }

        this.abortController?.abort();
        this.abortController = new AbortController();

        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variant.id);
        url.searchParams.set('section_id', this.dataset.sectionId);

        fetch(url.toString(), { signal: this.abortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`Inklapbare content kon niet worden geladen (${response.status})`);
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            this.querySelectorAll('[data-dynamic-collapsible-content="true"]').forEach((destination) => {
              const source = html.getElementById(destination.id);
              if (source) destination.innerHTML = source.innerHTML;
            });
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }
    }
  );
}
